"use client"


import React, {useEffect, useState} from "react";
import {VideoGardiLngModel, VideoGardiMainModel, VideoGardiModel} from "@/core/model/tmk.model";
import InfiniteScroll from 'react-infinite-scroll-component';
import {Loader} from "@/core/general/ui/loader.component";
import {Box, Container, Grid} from "@mui/material";
import {VIDEO_GARDI_MOVIES_PATH, VIDEO_GARDI_SERIES_PATH} from "@/core/CONSTANTS";
import {useRouter} from "next/navigation";
import {Row} from "@/core/general/row.component";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import Image from 'next/image';

interface Props{
    list:VideoGardiModel[]
    hasNext:string
    url:string
    title:string
}

export default function VideoListComponent(props:Props){

    const[videoList,setVideoList]=useState<VideoGardiModel[]>([])
    const [hasNextPage, setHasNextPage] = useState("test");
    const [page, setPage] = useState(1);
    const [title, setTitle] = useState("");
    const router=useRouter()

    useEffect(() => {
        if(page>1){
            fetchData(page)
        }
    }, [page]);

    useEffect(() => {
        setVideoList(props.list);
        setTitle(props.title);
        setHasNextPage(props.hasNext)
    }, [props.list]);

    const fetchData = async (pg:number) => {
        let url=props.url
        if(url.includes("?")){
            url=url.concat("&")
        }else {
            url = url.concat("?")
        }
        url=url.concat(`page=${pg}&page_size=30`)
        const api=await fetch(url,{
            method:"GET",
            headers:{
                'App-Version': `70000000`,
                'App-Package': process.env.NEXT_PUBLIC_PACKAGE ??'',
                'Content-Type': 'application/json',
                'Accept-Language': "fa",
                apikey: process.env.NEXT_PUBLIC_API_KEY + ''
            }
        })
        const data:VideoGardiMainModel=await api.json()
        const list=data.data.results
        setVideoList(videoList.concat(list))
        setHasNextPage((data.data?.next ?? ""))
    };

    function clickVideoItem(id:string,type:string,title:string){
        router.push(((type==="MOVIE")?VIDEO_GARDI_MOVIES_PATH:VIDEO_GARDI_SERIES_PATH)+`${id}/?shTitle=${title}`);
    }

    return (
        <Container maxWidth={'md'} className={"flex flex-col h-full w-full center hideScrollBar relative fade md:top-14"} disableGutters={true}>
            {title?
                <Row className={"absolute top-0 right-0 left-0 bgMain z-40 center"}>
                    <ArrowForwardIosOutlinedIcon className="p-2 cursor-pointer mText" onClick={()=>router.back()} fontSize={"large"} />
                    <div className={"w-full h-auto px-1 py-3 bgMain border-b mText"}>{title}</div>
                </Row>
                :null}
            <InfiniteScroll
                dataLength={videoList.length}
                next={() => setPage(page + 1)}
                height={"100vh"}
                className={`hideScrollBar ${title?"pt-14":"md:pt-14"}`}
                hasMore={hasNextPage!=""}
                loader={
                    <div className="flex justify-center" style={{ width: '100%', height: '3rem' }}>
                        <Loader isFullScreen={false}/>
                    </div>
                }
            >
                <Grid container spacing={2} className={"center"}>
                    {videoList.map((item, index) => (
                        <Grid key={index}>
                            <Box className={"relative my-2 cursor-pointer"} onClick={()=>clickVideoItem(item.id,item.type,(item?.title as VideoGardiLngModel)?.fa ?? "")}>
                                <Image src={item?.gallery?.poster ?? ""} alt={""} fill={true} quality={50} loading="lazy"
                                       className={"w-full shortVideoIconImage !relative rounded-md"}/>
                                <div className={"absolute bottom-0 w-full h-16 bg-gradient-to-t from-black to-transparent rounded-md"}></div>
                                <div
                                    className={"w-full text-center text-base px-2 max-h-12 text-ellipsis mb-2 overflow-hidden absolute bottom-0 text-white"}>{(item?.title as VideoGardiLngModel)?.fa ?? ""}</div>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </InfiniteScroll>
        </Container>
    )
}